module.exports = __webpack_public_path__ + "static/img/szafa_12.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/szafa_12.svg
// module id = wgpf
// module chunks = 0